import { gql } from "@apollo/client";

export default gql`
  mutation startMigration($type: oneTimesType!, $probe: InspectCollectionInput){
    startMigration(type: $type, probe: $probe){
        success
        data{
            _id
            type
            status
            succeeded
            startedAt
            finishedAt
            durationMs
            heartbeatAt
            countsBefore
            countsAfter
            result
            error
        }
        code
        message
    }
}
`
